import { combineReducers } from "redux";
import uiReducer from "./ui.reducer";
import userReducer from "./user.reducer";

const rootReducer = combineReducers({
  users: userReducer,
  sidebar: uiReducer
});

export default rootReducer;